export enum ArchiveJobType {
  Archive = 'Archive',
  Repost = 'Repost',
}
